import script from "./ModalLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalLayout.vue?vue&type=script&setup=true&lang=js"

import "./ModalLayout.vue?vue&type=style&index=0&id=f11511b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f11511b4"]])

export default __exports__